<template>
    <div class="-mt-14 relative">
        <img class="object-cover absolute h-full top-0 left-0 w-full" src="/img/header.jpg"/>
        <div class="container relative mx-auto py-4 md:py-36 px-4">
            <div class="w-full mdcd:w-1/2 ">
                <div class="bg-white p-10">
                    <h1 class="text-2xl mb-2">Herzlich willkommen beim Online-Heizkostenvergleich des BDEW</h1>
                    <div class="text-sm">
                        Der BDEW-Heizkostenvergleich gibt Bauherren, Architekten und Planern einen Überblick über die aktuelle Kostensituation bei verschiedenen Systemen zur Heizung und Warmwasserbereitung.
                    </div>
                    <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-4" role="alert">
                        <strong class="font-bold">
                          Mit dem 1. Januar 2024 treten die im Jahr 2023 beschlossenen Änderungen des Gebäudeenergiegesetzes – GEG in Kraft.
                          <br/><br/>
                          So wird ab dem 1. Januar 2024 ein Anteil von 65 Prozent Erneuerbaren Energien (oder unvermeidbarer Abwärme) für die mit einer neuen Heizungsanlage bereitgestellte Wärme vorgeschrieben. Dies gilt für nahezu alle neu eingebauten Heizungen im Neubau und mit Einschränkungen auch im Altbau.
                          Zudem ist die in diesem Zusammenhang umfassend überarbeitete Bundesförderung für effiziente Gebäude - BEG-EM, mit der u. a. Einzelmaßnahmen wie der Heizungstausch gefördert werden, zum Jahreswechsel 2023/24 in Kraft getreten.
                          <br/><br/>
                          Dies kann mit den bisher hinterlegten Daten des Tools nur sehr unzureichend abgebildet werden. Daher ist eine umfassende Überarbeitung und Neuberechnung des hier durch den BDEW bereitgestellten Heizkostenvergleichs-Tool notwendig.
                          <br/><br/>
                          Der BDEW wird das angepasste Tool schnellstmöglich (voraussichtlich bis Ende September) wieder zur Verfügung stellen.
                        </strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container mx-auto px-2 py-10">
        <div class="flex -mx-4 flex-wrap">
            <div class="w-full md:w-1/2 px-4">
                Auf Basis des BDEW-Heizkostenvergleiches berechnet dieses Online-Tool die jährlichen Heizkosten für alle üblichen Energieträger und Heiztechnologien und ermittelt auch, wie viel Treibhausgas die neue Anlage einspart. Die Webanwendung ermöglicht die Anpassung von Daten.
            </div>
            <div class="w-full md:w-1/2 px-4">
                Nach Eingabe Ihres Benutzernamens (Ihre E-Mail-Adresse) und ihres Passwortes können Sie dann den Heizkostenvergleich nutzen, zum Beispiel auch um einem Ihrer Kunden zu zeigen, mit welchen Energiekosten er – auf Basis dieser Beispielrechnung – etwa bei einem Wechsel des Energieträgers für die Beheizung seiner Immobilie rechnen kann.
            </div>
        </div>
    </div>

    <div class="relative">
        <img src="/img/stock_01.jpg" class="hidden md:block object-cover absolute w-1/2 h-full right-0 top-0 bg-primary-default"/>
        <div class="container mx-auto px-2 py-10 relative">
            <div class="flex -mx-4 flex-wrap pb-0 md:pb-12">
                <div class="w-full md:w-1/2 px-4">
                    <h2>Haben Sie noch Fragen? </h2>
                    <h3>Sollten Sie Fragen zum Online-Heizkostenvergleich haben, können Sie sich gern an Herrn Täschner wenden</h3>
                    <div class="mt-8">
                        <base-button :router-link="true" link="contact" button-class="invert">Kontakt aufnehmen</base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import {computed} from "vue";
import {useStore} from "vuex";

export default {
    setup() {
        const store = useStore();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn']);

        return {
            loggedIn
        }
    }
}
</script>
